import React from "react";

import MyCountdown from "../parts/countdown";
import Form from "../forms/form";
import {IoCalendar} from "react-icons/io5";
import {MdPlace} from "react-icons/md";
import DOMPurify from "dompurify";
import FirstScreenSpeacers from "../parts/firsrtscreen-speacers";

import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import HrwsLogo from "../../img/hrws_logo.svg";
import HrrwsLogoDesc from "../../img/hrws_logo_desc.svg";
import HeroDecor from "../../img/hero_bg.webp";
// import FormBg from "../../img/decor/form_bg.webp";
// import FormBgMob from "../../img/decor/form_bg_mob.webp";

function FirstScreenSlider({fsData}) {
    return (
        fsData ?
            <section className="pt-[90px] pb-[60px] lg:pb-[80px] xl:pt-32 relative" id="top">
                <img src={HeroDecor} className="absolute bottom-0 left-0 h-[45%] md:w-full md:h-full" alt="decor"/>
                <img src={HeroDecor} className="absolute top-14 left-0 w-full h-[25%]  md:hidden" alt="decor"/>

                <div className="container relative max-w-screen-xl mx-auto px-5">

                    <div className="grid grid-cols-1 w-full md:grid-cols-2 md:gap-6 
                        items-end lg:grid-cols-[60%,40%] xl:gap-14">
                        <div className="mb-8 md:mb-0 ">

                            <div className="flex flex-col gap-4 sm:gap-5 mb-4 sm:mb-8 md:items-end md:flex-row xl:items-end lg:justify-start">
                                <div className="flex gap-5 items-end">
                                    <div className="md:hidden"><img src={HrwsLogo} className="block w-[160px] md:hidden" alt="logo"/></div>
                                    <div className="hidden md:block max-w-[360px] xl:max-w-[460px]"><img src={HrrwsLogoDesc} alt="logo"/></div>
                                    <div className="md:hidden gap-6 lg:bg-transparent -mt-1">
                                        {/*<div className="flex items-center justify-end gap-2 uppercase text-sm font-medium text-[#010b13]">
                                            <span>08 липня 2026</span>
                                            <IoCalendar/>
                                        </div>*/}
                                        <div className="flex items-center justify-end gap-2 uppercase text-sm font-medium text-[#010b13]">
                                            
                                            <span>Київ</span>
                                            <MdPlace/>
                                        </div>
                                    </div>
                                </div>
                                <h2 className="md:hidden block text-2xl font-bold uppercase">Люди. Сенси. Форми</h2>
                                <div className="hidden md:block xl:flex justify-center gap-6 xl:-ml-[170px] md:shrink-0 md:-mb-1 xl:-mb-[6px]">
                                    {/* <div className="flex items-center gap-2 uppercase font-medium text-[#010b13] lg:text-2xl">
                                        <IoCalendar/>
                                        <span>08 липня 2026</span>
                                    </div>*/}
                                    <div className="flex items-center gap-2 uppercase font-medium text-[#010b13] lg:text-2xl">
                                        <MdPlace/>
                                        <span>Київ</span>
                                    </div>
                                </div> 
                                
                            </div>
                            <h2 className="text-[26px] font-bold uppercase lg:text-5xl xl:text-[60px] mb-4 md:flex-[100%] hidden md:block md:mb-12">Люди. Сенси. Форми</h2>
                            
                            <div className="px-4 py-6 sm:py-11 lg:p-10 relative bg-white form-box-clipped" style={{background: 'linear-gradient(222deg, #E2D9CB, #ffffff)'}}>

                                {/* <img src={FormBg} className="absolute top-0 left-0 w-full h-full z-10 hidden lg:block" alt="Decor"/> */}
                                {/* <img src={FormBgMob} className="absolute top-0 left-0 w-full z-10 lg:hidden" alt="Decor"/> */}

                                <div className="absolute top-0 left-0 md:shadow-[0px_0px_12px_0_rgba(0,0,0,0.15)] w-full h-full -z-10"></div>

                                {/*<MyCountdown/>*/}

                                <p className="font-bold uppercase mb-7 lg:text-2xl max-w-[540px] mr-10">Попередня реєстрація на HR Wisdom Summit 2027</p>

                                {/*<div className="mb-5 md:flex md:flex-wrap md:items-center md:gap-x-6 lg:mb-8 relative z-10">
                                    <p className="hidden uppercase text-[#010b13] font-medium md:block md:w-full md:max-w-[120px]">вартість</p>
                                    <div className="flex items-center gap-6 mb-1 lg:gap-6">
                                        <div className="flex items-end gap-[6px] py-[5px] px-[18px]
                                                xl:px-8">
                                            <span className="text-3xl font-bold leading-none xl:text-[42px]">6500</span>
                                            <span className="text-xs font-bold">грн*</span>
                                        </div>

                                        {/*<div className="flex items-end relative">
                                            <span className="text-3xl font-bold leading-none xl:text-[42px] text-[#62676C]">6500</span>
                                            <span className="text-xs font-bold">грн*</span>
                                            <span className="block absolute -left-[8px] top-1/2 -translate-y-1/2
                                                w-[90%] h-[3px] bg-[#b43125] opacity-80 -rotate-6"></span>
                                        </div>

                                    </div>
                                    <p className="text-xs font-light md:flex-[100%]">* Ціна до оподаткування</p>
                                </div>*/}
                                <Form/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        : ''
    )
}

export default FirstScreenSlider